import React from 'react';
import { Breadcrumbs, BreadcrumbItem } from '@cko/primitives';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export type BreadcrumbsItem = {
  label: string;
  href: string;
  selected?: boolean;
};

type BreadCrumbsProps = {
  items: Array<BreadcrumbsItem>;
};

const StyledBreadCrumbs = styled(Breadcrumbs)`
  height: 24px;
`;

export const BreadCrumb = ({ items }: BreadCrumbsProps) => {
  return (
    <StyledBreadCrumbs>
      {items.map((item: BreadcrumbsItem) => (
        <BreadcrumbItem
          key={item.href}
          selected={item.selected}
          // @ts-ignore
          to={item.href}
          as={RouterLink}
        >
          {item.label}
        </BreadcrumbItem>
      ))}
    </StyledBreadCrumbs>
  );
};
